/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * Form for probing a remote MCP server URL
 */
export type ProbeURLForm = {
  /**
   * The URL of the remote MCP server to probe
   */
  url: string;
};

/** @internal */
export type ProbeURLForm$Outbound = {
  url: string;
};

/** @internal */
export const ProbeURLForm$outboundSchema: z.ZodMiniType<
  ProbeURLForm$Outbound,
  ProbeURLForm
> = z.object({
  url: z.string(),
});

export function probeURLFormToJSON(probeURLForm: ProbeURLForm): string {
  return JSON.stringify(ProbeURLForm$outboundSchema.parse(probeURLForm));
}
